var headingFontWeight = 'bold';
export default (context => ({
  font: {
    headingFontFamily: '"F37 Bolton", Helvetica, Arial, sans-serif',
    bodyFontFamily: '"F37 Bolton", Helvetica, Arial, sans-serif',
    accentFontFamily: 'Georgia, serif',
    accentFontStyle: 'italic',
    headingFontWeight,
    h1FontWeight: headingFontWeight,
    h1FontSize: '48px',
    h1LineHeight: '60px',
    h1TabletFontSize: '40px',
    h1TabletLineHeight: '48px',
    h1MobileFontSize: '30px',
    h1MobileLineHeight: '36px',
    h2FontWeight: headingFontWeight,
    h2FontSize: '39px',
    h2LineHeight: '48px',
    h2TabletFontSize: '33px',
    h2TabletLineHeight: '42px',
    h2MobileFontSize: '26px',
    h2MobileLineHeight: '36px',
    h3FontWeight: headingFontWeight,
    h3FontSize: '31px',
    h3LineHeight: '36px',
    h3TabletFontSize: '28px',
    h3TabletLineHeight: '36px',
    h3MobileFontSize: '23px',
    h3MobileLineHeight: '30px',
    h4FontWeight: headingFontWeight,
    h4FontSize: '25px',
    h4LineHeight: '30px',
    h4TabletFontSize: '23px',
    h4TabletLineHeight: '30px',
    h4MobileFontSize: '20px',
    h4MobileLineHeight: '30px',
    h5FontWeight: headingFontWeight,
    h5FontSize: '20px',
    h5LineHeight: '24px',
    h5TabletFontSize: '19px',
    h5TabletLineHeight: '24px',
    h5MobileFontSize: '18px',
    h5MobileLineHeight: '24px',
    h6FontWeight: headingFontWeight,
    h6FontSize: '14px',
    h6LineHeight: '18px',
    h6TabletFontSize: '14px',
    h6TabletLineHeight: '18px',
    h6MobileFontSize: '14px',
    h6MobileLineHeight: '18px',
    baseFontSize: '16px',
    baseLineHeight: '24px',
    baseTabletFontSize: '16px',
    baseTabletLineHeight: '24px',
    baseMobileFontSize: '16px',
    baseMobileLineHeight: '24px',
    smallFontSize: '14px',
    smallLineHeight: '18px',
    smallTabletFontSize: '14px',
    smallTabletLineHeight: '18px',
    smallMobileFontSize: '14px',
    smallMobileLineHeight: '18px',
    xsmallFontSize: '12px',
    xsmallLineHeight: '18px',
    xsmallTabletFontSize: '12px',
    xsmallTabletLineHeight: '18px',
    xsmallMobileFontSize: '12px',
    xsmallMobileLineHeight: '18px',
    accentLargeFontSize: '38px',
    accentLargeLineHeight: '42px',
    accentLargeTabletFontSize: '26px',
    accentLargeTabletLineHeight: '36px',
    accentLargeMobileFontSize: '26px',
    accentLargeMobileLineHeight: '36px',
    accentMediumFontSize: '24px',
    accentMediumLineHeight: '30px',
    accentMediumTabletFontSize: '20px',
    accentMediumTabletLineHeight: '30px',
    accentMediumMobileFontSize: '20px',
    accentMediumMobileLineHeight: '30px'
  },
  colour: {
    text: context.colour.neutral600,
    textLight: context.colour.neutral400,
    textDark: context.colour.neutral700,
    heading: context.colour.neutral700,
    link: context.colour.secondary,
    linkHover: context.colour.secondaryDark,
    linkVisited: context.colour.neutral500
  }
}));